/**
 * @generated SignedSource<<344abcc02f597094e79f33c18497e97a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */
'use strict';

var node = function () {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "content"
  },
      v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "description"
  },
      v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
      v3 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "setAsDefault"
  },
      v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
      v5 = [{
    "alias": null,
    "args": [{
      "kind": "Variable",
      "name": "content",
      "variableName": "content"
    }, {
      "kind": "Variable",
      "name": "description",
      "variableName": "description"
    }, {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }, {
      "kind": "Variable",
      "name": "setAsDefault",
      "variableName": "setAsDefault"
    }],
    "concreteType": "business",
    "kind": "LinkedField",
    "name": "createLegalTermsDocument",
    "plural": false,
    "selections": [v4
    /*: any*/
    , {
      "alias": null,
      "args": null,
      "concreteType": "legalTermsDocType",
      "kind": "LinkedField",
      "name": "legalTermsDocuments",
      "plural": true,
      "selections": [v4
      /*: any*/
      , {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "concreteType": "businessSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultLegalTermsDocumentId",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }];
  return {
    "fragment": {
      "argumentDefinitions": [v0
      /*: any*/
      , v1
      /*: any*/
      , v2
      /*: any*/
      , v3
      /*: any*/
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "createLegalTermsDocumentMutation",
      "selections": v5
      /*: any*/
      ,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v2
      /*: any*/
      , v1
      /*: any*/
      , v0
      /*: any*/
      , v3
      /*: any*/
      ],
      "kind": "Operation",
      "name": "createLegalTermsDocumentMutation",
      "selections": v5
      /*: any*/

    },
    "params": {
      "cacheID": "efe3d9a9d50d195362b3c371bb7a2e7c",
      "id": null,
      "metadata": {},
      "name": "createLegalTermsDocumentMutation",
      "operationKind": "mutation",
      "text": "mutation createLegalTermsDocumentMutation(\n  $id: String\n  $description: String\n  $content: versionedDocumentContentInput!\n  $setAsDefault: Boolean\n) {\n  createLegalTermsDocument(id: $id, description: $description, content: $content, setAsDefault: $setAsDefault) {\n    id\n    legalTermsDocuments {\n      id\n      name\n    }\n    settings {\n      defaultLegalTermsDocumentId\n    }\n  }\n}\n"
    }
  };
}();

node.hash = "5a0ad7ae3cb5d1282f4b7c77a224f652";
module.exports = node;